import {
  FETCH_USERS_REQUESTED,
  FETCH_USERS_SUCCEED,
  FETCH_USERS_FAIL,
  FETCH_USER_REQUESTED,
  FETCH_USER_SUCCEED,
  FETCH_USER_FAIL,
  EDIT_USER_REQUESTED,
  EDIT_USER_SUCCEED,
  EDIT_USER_FAIL,
  FETCH_USER_PHOTO_REQUESTED,
  FETCH_USER_PHOTO_SUCCEED,
  FETCH_USER_PHOTO_FAIL,
  FETCH_USER_PHOTO_UPLOAD_REQUESTED,
  FETCH_USER_PHOTO_UPLOAD_SUCCEED,
  FETCH_USER_PHOTO_UPLOAD_FAIL, FETCH_USER_PHOTO_SELECT, FETCH_USER_PHOTO_SAVE_REQUESTED, FETCH_USER_PHOTO_SAVE_FAIL,
} from './actionTypes';

const UserErrors = {
  fetchUsersFailed: 'Не удалось обновить список пользователей.',
  fetchUsersDetails: 'Не удалось обновить данные о пользователе.',
  editUserFailed: 'Не удалось сохранить данные пользователя.'
};

export function fetchUsersRequested(params) {
  return {
    type: FETCH_USERS_REQUESTED,
    payload: params,
  };
}



export function fetchUsersSucceeded(params) {
  return {
    type: FETCH_USERS_SUCCEED,
    payload: params,
  };
}

export function fetchUsersFailed(params) {
  return {
    type: FETCH_USERS_FAIL,
    payload: params,
  };
}

export function fetchUserRequested(params) {
  return {
    type: FETCH_USER_REQUESTED,
    payload: params,
  };
}

export function fetchUserSucceeded(params) {
  return {
    type: FETCH_USER_SUCCEED,
    payload: params,
  };
}

export function fetchUserFailed(params) {
  return {
    type: FETCH_USER_FAIL,
    payload: params,
  };
}



export function editUserRequested(params) {
  return {
    type: EDIT_USER_REQUESTED,
    payload: params,
  };
}

export function editUserSucceeded(params) {
  return {
    type: EDIT_USER_SUCCEED,
    payload: params,
  };
}

export function editUserFailed(params) {
  return {
    type: EDIT_USER_FAIL,
    payload: params,
  };
}

export function fetchUserGalleryRequested(params) {
  return {
    type: FETCH_USER_PHOTO_REQUESTED,
    payload: params,
  };
}

export function fetchUserGallerySucceeded(params) {
  return {
    type: FETCH_USER_PHOTO_SUCCEED,
    payload: params,
  };
}

export function fetchUserGalleryFailed(params) {
  return {
    type: FETCH_USER_PHOTO_FAIL,
    payload: params,
  };
}

export function fetchUserPhotoUploadRequested(params) {
  return {
    type: FETCH_USER_PHOTO_UPLOAD_REQUESTED,
    payload: params,
  };
}

export function fetchUserPhotoSelect(params) {
  return {
    type: FETCH_USER_PHOTO_SELECT,
    payload: params,
  };
}
export function fetchUserPhotoUploadSucceeded(params) {
  return {
    type: FETCH_USER_PHOTO_UPLOAD_SUCCEED,
    payload: params,
  };
}

export function fetchUserPhotoUploadFailed(params) {
  return {
    type: FETCH_USER_PHOTO_UPLOAD_FAIL,
    payload: params,
  };
}

export function fetchUserPhotoSaveRequested(params) {
  return {
    type: FETCH_USER_PHOTO_SAVE_REQUESTED,
    payload: params,
  };
}
export function fetchUserPhotoSaveSucceeded(params) {
  return {
    type: FETCH_USER_PHOTO_UPLOAD_SUCCEED,
    payload: params,
  };
}

export function fetchUserPhotoSaveFailed(params) {
  return {
    type: FETCH_USER_PHOTO_SAVE_FAIL,
    payload: params,
  };
}



// WEBPACK FOOTER //
// ./src/store/users/actions.js